import { nanoid } from "nanoid";
import React from "react";
import { Component } from "react";
import TimeWorkingHours from "../../../src/windows/Applets/booking/components/TimeWorkingHours";
import HttpServices from "../../utils/Http.services";
import { translate } from "../../utils/useful";

class WorkingHours extends Component {
    state = {
        week: {
            'Sunday': { timing: [{ start: '9:00', end: '18:00', id: nanoid() }], locked: false, },
            'Monday': { timing: [{ start: '9:00', end: '18:00', id: nanoid() }], locked: true },
            'Tuesday': { timing: [{ start: '9:00', end: '18:00', id: nanoid() }], locked: true },
            'Wednesday': { timing: [{ start: '9:00', end: '18:00', id: nanoid() }], locked: true },
            'Thursday': { timing: [{ start: '9:00', end: '18:00', id: nanoid() }], locked: true },
            'Friday': { timing: [{ start: '9:00', end: '18:00', id: nanoid() }], locked: true },
            'Saturday': { timing: [{ start: '9:00', end: '18:00', id: nanoid() }], locked: false },
        },
        moment: require('jalali-moment'),
        item: {
            start: '00:00',
            end: '23:59',
            repeat: '00:10'
        },
        time: [],
        currentTime: '',
        locked: {},
        lockBox: false,
        setTheTime: false,
        checkBox: {},
        options: [],
        isLoading: false
    }
    componentDidMount() {
        this.generateTime()

        // console.log("DIDMOUNT")
        // console.log(this.props.fulldata)

        this.init(true)
    }
    componentDidUpdate(prevProps) {

        if (this.props.data != prevProps.data) {
            this.init()
        }

    }
    generateTime = () => {
        let startRepeat = this.state.moment.duration(this.state.item.start).asMinutes()
        let endRepeat = this.state.moment.duration(this.state.item.end).asMinutes()
        let repeat = this.state.moment.duration(this.state.item.repeat).asMinutes()
        let time = this.state.time
        let promises = []
        for (let j = startRepeat; j <= endRepeat; j += repeat) {
            promises.push(new Promise((resolve) => {
                let minutes = j % 60;
                minutes = String(minutes).padStart(2, '0')
                let hours = (j - minutes) / 60;
                hours = String(hours).padStart(2, '0')
                time.push(hours + ":" + minutes)
                resolve()
            }))
        }

        // console.log("generateTime",time)
        Promise.all(promises).then(() => {
            this.setState({ time })
            // this.changeValue(time)

        })
    }



    changeValue = (value) => {
        this.props.changeValue(this.props.header.key, value, this.props.extra)
    }

    init(mount) {

        // console.log(this.props.data)

        // if(!mount){
        //      
        // }
        // if (this.props.header.information) {
        //     if (this.props.header.information.type === "local") {
        //         this.setState({ options: this.props.header.information.items })
        //     } else if (this.props.header.information.type === "api") {
        //         this.fetch()
        //     }
        // }

        // console.log(this.props.data)

        if (!this.props.data) {
            // console.log("HERE", this.state.week)

            setTimeout(() => {
                if (!this.props.data) {
                    this.changeValue(this.state.week)
                }
            }, 200);
        } else {
            this.setState({ week: this.props.data })
            // this.changeValue(this.props.data)  

        }

    }
    // fetch() {

    //     // console.log("HERE")
    //     // console.log(this.props.header.information.filter)
    //     let filter = this.props.header.information.filter
    //     if (this.props.header.information.sort) {
    //         filter.sort = this.props.header.information.sort
    //     }

    //     for (const [key, value] of Object.entries(filter)) {
    //         if (/\{\{(.*?)\}\}/.test(value)) {

    //             if (this.props.variables) {
    //                 filter[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
    //             }
    //             // console.log("VAR")
    //         }
    //     }

    //     // console.log(filter)
    //     // console.log(this.props.variables)
    //     this.setState({ isLoading: true })
    //     HttpServices.request(this.props.header.information.address, filter, (fetchResult, fetchError) => {
    //         if (fetchError) { return }
    //         console.log(fetchResult)
    //         var newData = []
    //         fetchResult.info.forEach(element => {

    //             var newTitle = this.spliter(element, this.props.header.information.fields.title)
    //             var newValue = this.spliter(element, this.props.header.information.fields.value)

    //             newData.push({ value: newValue, title: newTitle })
    //         });
    //         // console.log("NEW DATA")
    //         // console.log(newData)
    //         // setTimeout(() => {

    //         if (this.props.data != null) {
    //             let found = false
    //             // console.log(this.props.data)

    //             newData.forEach(element => {
    //                 // console.log(element.value)
    //                 if (element.value == this.props.data) {
    //                     found = true
    //                 }

    //             });

    //             if (found == false) {
    //                 // console.log("DWLKFJWLK")
    //                 // this.props.changeValue(this.props.header.key, null, this.props.extra)
    //             }

    //         }


    //         this.setState({
    //             options: newData,
    //             isLoading: false
    //         })
    //         // }, 1000);


    //     })

    // }
    // spliter(source, string) {
    //     var stringArray = string.split('.')
    //     var finalString = source
    //     stringArray.forEach(element => {
    //         finalString = finalString[element]
    //     });
    //     return finalString
    // }
    setTiming = () => {
        const setTheTime = this.state.setTheTime
        this.setState({ setTheTime: !setTheTime })
    }
    addTimeBox = (key) => {
        let week = this.state.week
        week[key].timing.push({ start: '9:00 am', end: '6:00 pm', id: nanoid() })
        this.setState({ week })
    }
    deleteTimeBox = (key, index) => {
        let week = this.state.week
        week[key].timing.splice(index, 1)
        this.setState({ week })
    }
    lockInput = (key) => {
        let week = this.state.week
        week[key].locked = !week[key].locked
        console.log(week)
        this.setState({ week })
        this.changeValue(week)
    }
    setData = (key, value) => {
        this.setState({ [key]: value })
    }
    updateWeek = (key, value, type, index) => {
        let week = this.state.week

        week[key].timing[index][type] = value
        if (type == 'start' && week[key].timing[index]['end'] <= value) {
            week[key].timing[index]['end'] = null
            console.log("HERE")
        }
        console.log(week)


        this.setState({ week }, () => {
            this.changeValue(week)
        })

    }


    render() {
        // let info = this.props.header?.information
        // let dataValue = ''
        // if (this.props.data) {
        //     dataValue = typeof this.props.data == "object" ? (this.props.data._id ?? this.props.data.id) : this.props.data
        // }


        return (
            <div className="working-hours scroll-no-scrollbar">
                {this.state.week && Object.entries(this.state.week).map(([key, value], index) => {
                    return (
                        <div className="d-flex" key={key} style={{ borderBottom: index < 6 ? '1px solid #eee' : '' }} >


                            <div className="flex-1 pt-3">
                                <button className="flexc cursor-pointer p-0" onClick={() => this.lockInput(key)} >
                                    <input type="checkbox"
                                        className="hour-checkbox" checked={value.locked} />
                                    <p className="text-semibold font-size-15 mx-2 ">{translate(key)}</p>
                                </button>
                            </div>

                            {/* <div>
                            <button className={"checkbox-container position-relative "} onClick={() => this.lockInput(key)} >
                                <input type="checkbox" checked={value.locked} />
                                <span className="checkmark"></span>
                                <div  className='position-absolute top-0 left-0 w-100 h-100'>
                                </div>

                                <p className="text-semibold font-size-15 mx-2 ">{translate(key)}</p>
                            </button>
                            </div> */}

                            <div className="flex-2">

                                <div>
                                    {Array.isArray(value.timing) && value.timing.map((item, num) => {
                                        return (

                                            <div className="flexc flex-1" key={item.id}>

                                                <TimeWorkingHours data={item.start} locked={value.locked} type={'start'} time={this.state.time} startEnd={item.start} setData={this.setData} weekKey={key} index={num} updateWeek={this.updateWeek} currentTime={this.state.currentTime} />
                                                <p className="flexcc">&nbsp;-&nbsp;</p>
                                                <TimeWorkingHours data={item.end} locked={value.locked} startTime={item.start} type={'end'} time={this.state.time} startEnd={item.end} setData={this.setData} weekKey={key} index={num} updateWeek={this.updateWeek} currentTime={this.state.currentTime} />
                                                <div className="flexc" style={{ alignItems: 'flex-end', width: '40px' }}>
                                                    <div style={{ width: '20px' }}>
                                                        {num == value.timing?.length - 1 && (
                                                            <button className="flexcc p-0" onClick={() => this.addTimeBox(key)}>
                                                                <img width={15} src="/assets/icons/plus.svg" style={{ opacity: '70%', display: !value.locked && 'none' }} alt="" />
                                                            </button>
                                                        )}
                                                    </div>
                                                    <div style={{ width: '20px' }}>
                                                        {value.timing?.length != 1 && (

                                                            <button className="flexcc p-0" onClick={() => this.deleteTimeBox(key, num)} >
                                                                <img width={15} src="/assets/icons/trash.svg" style={{}} alt="" />
                                                            </button>
                                                        )}

                                                    </div>
                                                </div>

                                            </div>
                                        )
                                    })}
                                    {/* </div> */}
                                </div>
                            </div>
                            {/* {value.locked && */}

                            {/* } */}
                        </div>
                        
                    )
                })
                }
                {/* {this.state.setTheTime == true &&
                    <div className="set-time scroll-no-scrollbar ">
                        {this.state.time.map((item, index) => {
                            return (
                                <div className="set-time-item" style={{}}>
                                    {item}
                                </div>
                            )
                        })}
                    </div>
                } */}
            </div >
        );
    }

}

export default WorkingHours;